import {useEffect} from 'react';

import { Link } from 'react-router-dom';

import RecordsManagement from './RecordsManagement';
import TemperatureControlledAmbient from './TemperatureControlledAmbient';
import ValueAddedServices from './ValueAddedServices';


const Warehousing = () => {
    
    useEffect(()=>{
        let current_page = window.location.href.split('/').at(-1)
        setTimeout(()=>{
            document.getElementById(`${current_page}`)?.scrollIntoView({ block: 'center', behavior: 'smooth' });
        }, 100)
    })
    window.addEventListener("scroll", function(event) {
        let top = this.scrollY,
            window_width = window.innerWidth,
            header_height = document.querySelector("header").style.height+100;
            // (top > header_height && window_width > 1024) ? document.querySelector("nav").classList.add('fixed-header-desktop') : document.querySelector("nav").classList.remove('fixed-header-desktop')
            (top > header_height && window_width > 1024) ? document.querySelector("a").classList.add('fixed-header-desktop') : document.querySelector("a").classList.remove('fixed-header-desktop')
    }, false);  
    window.addEventListener("scroll", function(event) {
        let top = this.scrollY,
            window_width = window.innerWidth,
            header_height = document.querySelector("header").style.height+100;
            (top > header_height && window_width > 1024) ? document.querySelector("nav").classList.add('fixed-header-desktop') : document.querySelector("nav").classList.remove('fixed-header-desktop')
            // (top > header_height && window_width > 1024) ? document.querySelector("a").classList.add('fixed-header-desktop') : document.querySelector("a").classList.remove('fixed-header-desktop')
    }, false);   
  
      
  
    return(
        <div>
            <div id='international' className="warehousing-image">
                <img src='/warehousing/Warehousing-Product-Banner.jpg' alt='' className='w-[100%]'/>
            </div>
            <div className="flex flex-col justify-center gap-4 max-w-[50rem] lg:mx-auto md:mx-auto mx-[2rem]  md:p-[2rem] pt-[1rem] lg:pb-[50px]  pb-[1rem]">
                <p>
                    TCS offers state-of-the-art, dedicated, as well as multi-user warehousing, with over 650,000 square feet 
                    of space in Pakistan. The inventory management & warehousing processes are automated. We also offer a 
                    web-based Inventory Management System (WIMS), which provides real-time, online information to help 
                    customers order, monitor and manage their stocks efficiently.
                </p>
                <p>
                    Integrated logistics and dynamic sourcing allow for increasing efficiency and reducing costs, 
                    to meet the modern day logistics challenges. A broad suite of innovative applications provided 
                    by TCS enables organisations to modernise their supply chain processes by adding cloud-based 
                    warehouse management capabilities.
                </p>
                
                <div className="MuiFormGroup-root MuiFormGroup-row">
                    <div className="lg:flex grid pb-[50px]">
                        <div className="lg:flex-1 lg:flex lg:flex-col grid">
                            <div className="flex items-center lg:w-[27rem]">
                                <li><Link to="/Warehousing/temperature-controlled-ambient"  className='font-bold'>Temperature Controlled and Ambient Warehousing</Link></li>
                            </div>
                            <div className="flex items-center">
                                <li><Link to="/Warehousing/records-management" className='font-bold'>Records Management</Link></li>
                            </div>

                           
                        </div>

                        <div className="flex-1 flex flex-col">
                        <div className="flex items-center">
                                <li><Link to="/Warehousing/value-added-services" className='font-bold'>Value-added Services</Link></li>
                            </div>
                            
                        </div>
                            
                    </div>
                </div> 
                
                 
            </div>
            
            <div className='mx-[2rem] md:mx-[0rem]'>
            <div id="temperature-controlled-ambient">
                <TemperatureControlledAmbient/>
            </div>
            <div id="records-management">
                <RecordsManagement/>
            </div>
            <div id="value-added-services">
                <ValueAddedServices/>
            </div>
            </div>
           

            

        </div>
    )
};
export default Warehousing;